module.exports = __webpack_public_path__ + "static/media/Gilroy-Bold.20fa78ce.ttf";